export default __webpack_public_path__ + "static/media/report.0118cd76.jpg";